import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import { fetchAdminDashboard } from '../../api/admin';
import { AdminStatCard } from '../../components/admin';
import {
  FiUsers, FiStar, FiDollarSign, FiCalendar,
  FiMessageSquare, FiShield, FiZap, FiAlertCircle,
} from 'react-icons/fi';

interface DashboardStats {
  total_users: number;
  total_experts: number;
  active_subscriptions: number;
  total_bookings: number;
  bookings_30d: number;
  revenue_30d: string;
  copilot_conversations: number;
  blacklisted_users: number;
  open_tickets: number;
}

const AdminDashboard: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.theme);
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdminDashboard()
      .then((res) => setStats(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: colors.primary, borderTopColor: 'transparent' }} />
      </div>
    );
  }

  if (!stats) {
    return <div className="p-6 text-center" style={{ color: colors.grayScale500 }}>Failed to load dashboard</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-6" style={{ color: colors.textColor }}>Admin Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <AdminStatCard label="Total Users" value={stats.total_users} icon={FiUsers} />
        <AdminStatCard label="Total Experts" value={stats.total_experts} icon={FiStar} color="#F59E0B" />
        <AdminStatCard label="Active Subscriptions" value={stats.active_subscriptions} icon={FiZap} color="#8B5CF6" />
        <AdminStatCard label="Bookings (30d)" value={stats.bookings_30d} icon={FiCalendar} color="#10B981" />
        <AdminStatCard label="Revenue (30d)" value={`Rs ${stats.revenue_30d}`} icon={FiDollarSign} color="#059669" />
        <AdminStatCard label="Copilot Conversations" value={stats.copilot_conversations} icon={FiMessageSquare} color="#3B82F6" />
        <AdminStatCard label="Blacklisted Users" value={stats.blacklisted_users} icon={FiShield} color="#EF4444" />
        <AdminStatCard label="Open Tickets" value={stats.open_tickets} icon={FiAlertCircle} color="#F97316" />
        <AdminStatCard label="Total Bookings" value={stats.total_bookings} icon={FiCalendar} color="#6366F1" />
      </div>
    </div>
  );
};

export default AdminDashboard;
